import createTheme from '@mui/material/styles/createTheme';

const theme = createTheme({
  // palette: {
  //   primary: {
  //     light: '#63b4ff',
  //     main: '#1a85cd',
  //     dark: '#00599c',
  //     contrastText: '#fff',
  //   },
  //   secondary: {
  //     light: '#78e1df',
  //     main: '#41afad',
  //     dark: '#007f7e',
  //     contrastText: '#fff',
  //   },
  //   success: {
  //     light: '#81c784',
  //     main: '#66bb6a',
  //     dark: '#388e3c',
  //     contrastText: '#fff',
  //   },
  //   info: {
  //     light: '#c4b5f6',
  //     main: '#2196f3',
  //     dark: '#1976d2',
  //     contrastText: '#fff',
  //   },
  //   error: {
  //     light: '#e57373',
  //     main: '#f44336',
  //     dark: '#d32f2f',
  //     contrastText: '#fff',
  //   },
  // },
  components: {
    MuiButton: {
      defaultProps: {
        variant: 'contained',
      },
    },
  },
  typography: {
    fontFamily: 'Open Sans',
    h1: {
      fontSize: '2.5rem',
    },
    h2: {
      fontSize: '1.85rem',
    },
    h3: {
      fontSize: '1.65rem',
    },
    h4: {
      fontSize: '1.45rem',
    },
    h5: {
      fontSize: '1.25rem',
    },
    h6: {
      fontSize: '1.15rem',
    },
    subtitle1: {
      fontSize: '1.15rem',
    },
    subtitle2: {
      fontWeight: 500,
      fontSize: '1.1rem',
    },
    body1: {
      fontSize: '1rem',
    },
    body2: {
      fontWeight: 600,
      fontSize: '1rem',
    },
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 700,
  },
  text: {
    primary: 'rgba(19, 19, 19, 0.87)',
  },
});

export default theme;
